import getVbaToken from 'communicator/utils/get-vba-token';

export default getVbaToken;
